import React, { useState } from "react";
import BatchUpdateSection from "../batchUpdate";
import FilterSection from "../filterSection";

const FilterAndBatchUpdate = ({
  handleCloseFilter,
  handleCloseBatch,
  handleFilter,
  loading,
  showFilter,
  setShowFilter,
  showBatch,
  setShowBatch,
  handleBatchUpdate,
  project_id,
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [dynamicFieldsOptions, setDynamicFieldsOptions] = useState([]);
  const [filterDataFetched, setFilterDataFetched] = useState(false);

  const onCloseFilter = () => {
    setSelectedTemplate({});
    handleCloseFilter();
  };

  return (
    <>
      {showFilter && (
        <FilterSection
          handleClose={onCloseFilter}
          handleFilter={handleFilter}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          setFilterDataFetched={setFilterDataFetched}
          dynamicFieldsOptions={dynamicFieldsOptions}
          setDynamicFieldsOptions={setDynamicFieldsOptions}
          project_id={project_id}
        />
      )}
      {showBatch && (
        <BatchUpdateSection
          handleClose={handleCloseBatch}
          handleFilter={handleBatchUpdate}
          loading={loading}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          filterDataFetched={filterDataFetched}
          dynamicFieldsOptions={dynamicFieldsOptions}
          setDynamicFieldsOptions={setDynamicFieldsOptions}
        />
      )}
    </>
  );
};

export default FilterAndBatchUpdate;
